import Splide from '@splidejs/splide'
import '@splidejs/splide/css'

export class ProgramSlider {
  constructor() {
    const options = {
      perPage: 1,
      pagination: false,
      arrows: false,
      gap: 40,
      breakpoints: {
        758: {
          perPage: 1,
          destroy: true,
        },
      },
    }
    document.addEventListener('DOMContentLoaded', function () {
      const elm = document.querySelector('.js-program_slider')
      if (!elm) return
      const splide = new Splide('.js-program_slider', options)
      splide.mount()
    })
  }
}
